import React from "react";
import { pure } from "recompose";
import { defineMessages, injectIntl, FormattedDate, FormattedTime } from "react-intl";
import moment from "moment";
import styled from "styled-components";
import { renderHTML } from "../../../utils/misc";
import media from "../../../utils/media";

const msgs = defineMessages({
  bookNow: {
    id: "checkout.payment_form.bookNow",
    description: "Book now and <b> pay online before </b>",
    defaultMessage: "Book now and <b> pay online before </b>",
  },
  at: {
    id: "checkout.payment_form.at",
    description: "<b> at </b>",
    defaultMessage: "<b> at </b>",
  },
  defaultDescription: {
    id: "checkout.payment_form.defaultDeferredMessage",
    description:
      "We will keep the reservation until then. Pay when it's best for you, at no additional charge. <br /> <br /> We'll send you an email reminder with a link to pay online before the deadline.",
    defaultMessage:
      "We will keep the reservation until then. Pay when it's best for you, at no additional charge. <br /> <br /> We'll send you an email reminder with a link to pay online before the deadline.",
  },
});

const StyledContainer = styled.div`
  font-size: 12px;
  color: #908f96;
  ${media.up.md`
    font-size: 14px;
  `};
`;

const StyledDate = styled.span`
  display: inline-block;
  font-weight: 700;
`;

const Deferred = ({ expiration, description, intl: { formatMessage } = {} }) => {
  let expirationDate = expiration && moment(expiration);
  let daysDiff = moment(expirationDate).diff(moment(), "days");
  if (daysDiff <= 0) {
    expirationDate = moment(expirationDate).add(Math.abs(daysDiff) + 1, "d");
  }
  return (
    <StyledContainer>
      {expirationDate && (
        <StyledDate>
          <span dangerouslySetInnerHTML={renderHTML(formatMessage(msgs.bookNow))} />{" "}
          <FormattedDate value={expirationDate} year="numeric" month="long" day="2-digit" />
          {","}
          <span dangerouslySetInnerHTML={renderHTML(formatMessage(msgs.at))} />
          <FormattedTime value={expirationDate} />
          {"."}
          <br />
          <br />
        </StyledDate>
      )}
      {description && <span dangerouslySetInnerHTML={renderHTML(description)} />}
      {!description && (
        <span dangerouslySetInnerHTML={renderHTML(formatMessage(msgs.defaultDescription))} />
      )}
    </StyledContainer>
  );
};

export default injectIntl(pure(Deferred));
